interface ConfigOptions {
    clientId: string;
    startLoginPageUrl: string;
    apiEndpoint: string;
    scope: string;
}

const configOptions: ConfigOptions = {
    clientId: process.env.REACT_APP_CLIENT_ID!,
    startLoginPageUrl: process.env.REACT_APP_START_LOGIN_PAGE_URL!,
    apiEndpoint: process.env.REACT_APP_API_ENDPOINT!,
    scope: process.env.REACT_APP_SCOPE!
};

export default configOptions;